// MADDOG GIFT CARD — Phase 5B.10 live-theme JS
//
// Only loaded on the maddog-gift-card product template AND only when
// the launch metafield is true. Handles:
//   * SEND_TO_ME / SEND_AS_GIFT toggle (show/hide recipient panel)
//   * SEND NOW / CHOOSE A DATE toggle (show/hide date field)
//   * date field min/max (today+1 → today+365)
//   * message counter (0 / 500)
//   * dynamic CTA amount: reads the checked denomination and mirrors
//     it into the "GIVE MADDOG — $XX" CTA label
//   * safety: recipient fields are cleared when switching back to FOR ME
//   * safety: date field is cleared when switching back to SEND NOW
//
// Never writes to global scope. Never touches non-.maddog-gc-* elements.

(function () {
  "use strict";

  var form = document.querySelector(".maddog-gc-form");
  if (!form) return;

  var maxMsg = parseInt(form.dataset.maxMsg || "500", 10);
  var minOffset = parseInt(form.dataset.minDateOffset || "1", 10);
  var maxOffset = parseInt(form.dataset.maxDateOffset || "365", 10);

  // --- Dynamic CTA amount ---
  //
  // The CTA reads its amount from whichever denomination radio is
  // currently checked. This keeps the visible price honest even if
  // the customer changes denomination mid-flow.
  var ctaAmount = form.querySelector("[data-cta-amount]");

  function currentDenominationDisplay() {
    var checked = form.querySelector('input[name="id"]:checked');
    if (checked) {
      var disp = checked.getAttribute("data-price-display");
      if (disp) return disp;
      var cents = parseInt(checked.getAttribute("data-price-cents") || "", 10);
      if (!isNaN(cents) && cents > 0) {
        return "$" + Math.round(cents / 100);
      }
    }
    return null;
  }

  function refreshCta() {
    if (!ctaAmount) return;
    var d = currentDenominationDisplay();
    if (d) ctaAmount.textContent = d;
  }
  refreshCta();

  form.querySelectorAll('input[name="id"]').forEach(function (r) {
    r.addEventListener("change", refreshCta);
  });

  // --- SEND_TO_ME / SEND_AS_GIFT toggle ---

  var recipientPanel = form.querySelector(".maddog-gc-recipient");

  function showRecipient() {
    if (!recipientPanel) return;
    recipientPanel.hidden = false;
    recipientPanel.setAttribute("aria-hidden", "false");
  }
  function hideRecipient() {
    if (!recipientPanel) return;
    recipientPanel.hidden = true;
    recipientPanel.setAttribute("aria-hidden", "true");
    // Clear so we never accidentally submit recipient fields when
    // the customer switched back to FOR ME.
    recipientPanel.querySelectorAll("input, textarea").forEach(function (f) {
      if (f.type !== "radio") f.value = "";
    });
    // Reset delivery-mode radios to SEND NOW default.
    var nowRadio = form.querySelector(
      'input[name="properties[_maddog_gc_delivery_mode]"][value="NOW"]');
    if (nowRadio) nowRadio.checked = true;
    var dateWrap = form.querySelector(".maddog-gc-date");
    if (dateWrap) {
      dateWrap.hidden = true;
      dateWrap.setAttribute("aria-hidden", "true");
    }
    // Reset counter.
    var ctr2 = form.querySelector("#maddog-gc-msg-counter");
    if (ctr2) ctr2.textContent = "0 / " + maxMsg;
  }

  form.querySelectorAll('[data-toggle="show-recipient"]').forEach(function (i) {
    i.addEventListener("change", showRecipient);
  });
  form.querySelectorAll('[data-toggle="hide-recipient"]').forEach(function (i) {
    i.addEventListener("change", hideRecipient);
  });

  // --- SEND NOW / CHOOSE A DATE toggle ---

  form.querySelectorAll('[data-toggle="show-date"]').forEach(function (i) {
    i.addEventListener("change", function () {
      var d = form.querySelector(".maddog-gc-date");
      if (d) {
        d.hidden = false;
        d.setAttribute("aria-hidden", "false");
      }
    });
  });

  form.querySelectorAll('[data-toggle="hide-date"]').forEach(function (i) {
    i.addEventListener("change", function () {
      var d = form.querySelector(".maddog-gc-date");
      if (!d) return;
      d.hidden = true;
      d.setAttribute("aria-hidden", "true");
      var input = d.querySelector('input[type="date"]');
      if (input) input.value = "";
    });
  });

  // --- date field min/max ---

  function iso(x) {
    var yr = x.getFullYear();
    var mo = String(x.getMonth() + 1).padStart(2, "0");
    var da = String(x.getDate()).padStart(2, "0");
    return yr + "-" + mo + "-" + da;
  }

  var now = new Date();
  var minDate = new Date(now.getFullYear(), now.getMonth(),
                          now.getDate() + minOffset);
  var maxDate = new Date(now.getFullYear(), now.getMonth(),
                          now.getDate() + maxOffset);
  var dateInput = form.querySelector('input[type="date"]');
  if (dateInput) {
    dateInput.min = iso(minDate);
    dateInput.max = iso(maxDate);
  }

  // --- message counter ---

  var msg = form.querySelector(
    'textarea[name="properties[_maddog_gc_message]"]');
  var ctr = form.querySelector("#maddog-gc-msg-counter");
  if (msg && ctr) {
    msg.addEventListener("input", function () {
      var len = msg.value.length;
      if (len > maxMsg) {
        msg.value = msg.value.slice(0, maxMsg);
        len = maxMsg;
      }
      ctr.textContent = len + " / " + maxMsg;
    });
  }
})();
